import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHappy = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 356,
	height: 283,
	viewBox: "0 0 356 283",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_21_639)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M353.493 168.145C359.313 211.584 351.388 255.07 311.076 272.003C270.764 288.937 224.397 269.892 207.511 229.466C190.626 189.04 230.466 164.852 249.928 125.608C289.45 45.9149 335.418 33.2461 353.493 168.145Z",
					fill: "#F2F2F2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M280.919 283C315.802 283 344.079 279.142 344.079 274.383C344.079 269.624 315.802 265.766 280.919 265.766C246.037 265.766 217.76 269.624 217.76 274.383C217.76 279.142 246.037 283 280.919 283Z",
					fill: "#3F3D56"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M255 248.184L239.602 252.453L241.977 261.072L257.375 256.803L255 248.184Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M240.663 262.596C242.146 262.185 242.462 258.636 241.369 254.669C240.275 250.702 238.187 247.82 236.703 248.231C235.22 248.642 234.904 252.191 235.997 256.158C237.091 260.125 239.18 263.007 240.663 262.596Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M288.204 222.81C289.293 214.756 288.131 207.949 285.61 207.606C283.089 207.263 280.162 213.515 279.074 221.569C277.985 229.624 279.146 236.431 281.668 236.773C284.189 237.116 287.116 230.865 288.204 222.81Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M280.766 279.176C296.976 279.176 310.116 265.998 310.116 249.742C310.116 233.486 296.976 220.308 280.766 220.308C264.556 220.308 251.415 233.486 251.415 249.742C251.415 265.998 264.556 279.176 280.766 279.176Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M255 242.968L239.602 247.237L241.977 255.856L257.375 251.587L255 242.968Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M240.663 257.38C242.146 256.968 242.462 253.419 241.369 249.453C240.275 245.486 238.187 242.604 236.703 243.015C235.22 243.426 234.904 246.975 235.997 250.942C237.091 254.908 239.18 257.791 240.663 257.38Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M288.472 242.94C294.012 242.94 298.503 238.436 298.503 232.88C298.503 227.324 294.012 222.82 288.472 222.82C282.932 222.82 278.44 227.324 278.44 232.88C278.44 238.436 282.932 242.94 288.472 242.94Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M291.681 231.789C293.527 231.789 295.024 230.288 295.024 228.436C295.024 226.584 293.527 225.083 291.681 225.083C289.834 225.083 288.337 226.584 288.337 228.436C288.337 230.288 289.834 231.789 291.681 231.789Z",
					fill: "#3F3D56"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M314.66 269.969C325.521 269.423 333.84 259.235 333.24 247.213C332.64 235.19 323.349 225.886 312.487 226.431C301.626 226.976 299.921 235.527 300.521 247.549C301.121 259.572 303.798 270.514 314.66 269.969Z",
					fill: "#0077C8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M268.77 237.288C267.002 237.431 265.25 236.865 263.899 235.713C262.547 234.56 261.708 232.917 261.565 231.144C261.422 229.371 261.987 227.614 263.136 226.259C264.285 224.904 265.923 224.062 267.691 223.919C271.372 223.62 272.376 226.551 272.674 230.243C272.972 233.934 272.451 236.989 268.77 237.288Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M297.863 188.791H251.003V212.696H297.863V188.791Z",
					fill: "#0077C8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M277.188 229.804C278.276 221.75 277.115 214.943 274.593 214.6C272.072 214.257 269.146 220.509 268.057 228.563C266.968 236.617 268.13 243.425 270.651 243.767C273.173 244.11 276.099 237.858 277.188 229.804Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M210.969 233.903C212.31 233.903 213.397 232.812 213.397 231.468C213.397 230.123 212.31 229.033 210.969 229.033C209.628 229.033 208.541 230.123 208.541 231.468C208.541 232.812 209.628 233.903 210.969 233.903Z",
					fill: "#E67300"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M313.156 132.737C313.118 132.738 313.08 132.732 313.044 132.72C214.81 101.565 128.23 105.639 72.8961 114.543C65.3658 115.754 57.8153 117.153 50.4544 118.702C48.5752 119.096 46.6256 119.52 44.6598 119.96C42.3122 120.484 39.9958 121.024 37.7746 121.564C36.8153 121.792 35.8747 122.022 34.9529 122.253C33.5566 122.599 32.1398 122.959 30.621 123.355C28.9239 123.794 27.1996 124.254 25.4949 124.723C25.4887 124.725 25.4823 124.727 25.4759 124.728L25.4761 124.729C23.5506 125.256 21.6353 125.799 19.7831 126.34C18.7806 126.631 17.8126 126.917 16.8854 127.2C16.7818 127.228 16.69 127.256 16.597 127.284L16.3978 127.345C16.2824 127.381 16.1685 127.415 16.0545 127.448L16.0473 127.45L16.0475 127.45L15.746 127.544C15.3864 127.653 15.0356 127.76 14.6905 127.866C5.5714 130.685 0.558317 132.691 0.508793 132.711C0.463505 132.729 0.415085 132.738 0.366298 132.737C0.317511 132.737 0.269312 132.727 0.224453 132.707C0.179593 132.688 0.138952 132.66 0.10485 132.625C0.0707474 132.59 0.0438513 132.549 0.0256981 132.503C0.00754493 132.458 -0.00151159 132.409 -0.000952138 132.36C-0.000392685 132.312 0.00977091 132.263 0.0289578 132.218C0.0481448 132.173 0.0759796 132.132 0.110873 132.098C0.145766 132.064 0.187036 132.037 0.232324 132.019C0.282213 131.999 5.31978 129.984 14.4721 127.154C14.8184 127.047 15.1702 126.941 15.5308 126.831L15.8109 126.744C15.8205 126.74 15.8301 126.737 15.8399 126.734C15.9533 126.702 16.0665 126.667 16.1815 126.632L16.3811 126.572C16.4805 126.542 16.5784 126.512 16.6788 126.484C17.5996 126.203 18.5709 125.916 19.5759 125.625C21.4288 125.082 23.3459 124.54 25.2729 124.012C25.2789 124.01 25.285 124.008 25.291 124.007V124.006C27.0017 123.536 28.7324 123.074 30.4349 122.633C31.956 122.237 33.3756 121.876 34.7742 121.53C35.7 121.299 36.6423 121.069 37.6013 120.84C39.8251 120.299 42.1462 119.758 44.498 119.233C46.4668 118.792 48.4197 118.368 50.302 117.972C57.6743 116.422 65.2366 115.021 72.7784 113.807C128.191 104.891 214.895 100.81 313.268 132.01C313.353 132.037 313.425 132.093 313.472 132.168C313.518 132.244 313.537 132.334 313.523 132.422C313.51 132.51 313.465 132.59 313.398 132.648C313.331 132.706 313.245 132.738 313.156 132.738L313.156 132.737Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M89.3629 127.128C92.2566 119.536 92.6758 112.642 90.299 111.731C87.9223 110.82 83.6498 116.237 80.7561 123.829C77.8624 131.421 77.4433 138.314 79.82 139.225C82.1967 140.136 86.4692 134.72 89.3629 127.128Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M91.7417 116.883C94.5498 116.883 96.8262 114.6 96.8262 111.784C96.8262 108.968 94.5498 106.685 91.7417 106.685C88.9336 106.685 86.6572 108.968 86.6572 111.784C86.6572 114.6 88.9336 116.883 91.7417 116.883Z",
					fill: "#0077C8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M162.244 84.6495C161.087 84.6495 159.955 84.3052 158.992 83.6602C158.03 83.0152 157.279 82.0984 156.836 81.0257C156.393 79.9531 156.277 78.7728 156.503 77.6341C156.729 76.4953 157.286 75.4493 158.105 74.6284C158.924 73.8074 159.967 73.2483 161.102 73.0218C162.238 72.7952 163.415 72.9115 164.484 73.3558C165.554 73.8 166.468 74.5524 167.111 75.5178C167.755 76.4831 168.098 77.6181 168.098 78.7791C168.096 80.3355 167.479 81.8276 166.382 82.9281C165.284 84.0286 163.796 84.6477 162.244 84.6495ZM162.244 73.6541C161.234 73.6541 160.245 73.9547 159.405 74.5178C158.565 75.081 157.91 75.8814 157.523 76.8179C157.136 77.7544 157.035 78.7849 157.232 79.779C157.429 80.7732 157.916 81.6864 158.631 82.4032C159.345 83.12 160.256 83.6081 161.247 83.8058C162.239 84.0036 163.266 83.9021 164.2 83.5142C165.134 83.1263 165.932 82.4693 166.494 81.6265C167.055 80.7837 167.355 79.7928 167.355 78.7791C167.353 77.4203 166.814 76.1177 165.856 75.1569C164.898 74.1961 163.599 73.6556 162.244 73.6541Z",
					fill: "#3F3D56"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M203.114 151.714C201.956 151.714 200.824 151.37 199.861 150.725C198.899 150.08 198.148 149.163 197.705 148.09C197.262 147.018 197.146 145.837 197.372 144.699C197.598 143.56 198.156 142.514 198.974 141.693C199.793 140.872 200.836 140.313 201.971 140.086C203.107 139.86 204.284 139.976 205.353 140.42C206.423 140.865 207.337 141.617 207.98 142.582C208.624 143.548 208.967 144.683 208.967 145.844C208.965 147.4 208.348 148.892 207.251 149.993C206.153 151.093 204.665 151.712 203.114 151.714ZM203.114 140.719C202.103 140.719 201.115 141.019 200.274 141.583C199.434 142.146 198.779 142.946 198.392 143.883C198.005 144.819 197.904 145.85 198.101 146.844C198.298 147.838 198.785 148.751 199.5 149.468C200.214 150.185 201.125 150.673 202.116 150.871C203.108 151.068 204.135 150.967 205.069 150.579C206.003 150.191 206.801 149.534 207.363 148.691C207.924 147.848 208.224 146.857 208.224 145.844C208.223 144.485 207.684 143.182 206.726 142.222C205.767 141.261 204.468 140.72 203.114 140.719Z",
					fill: "#3F3D56"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M115.804 184.502C114.646 184.502 113.514 184.157 112.552 183.512C111.589 182.867 110.839 181.95 110.396 180.878C109.953 179.805 109.837 178.625 110.063 177.486C110.289 176.348 110.846 175.302 111.665 174.481C112.483 173.66 113.526 173.101 114.662 172.874C115.797 172.648 116.974 172.764 118.044 173.208C119.113 173.652 120.027 174.405 120.671 175.37C121.314 176.335 121.657 177.47 121.657 178.631C121.656 180.188 121.038 181.68 119.941 182.78C118.844 183.881 117.356 184.5 115.804 184.502ZM115.804 173.506C114.793 173.506 113.805 173.807 112.964 174.37C112.124 174.933 111.469 175.734 111.082 176.67C110.695 177.607 110.594 178.637 110.791 179.631C110.989 180.625 111.475 181.539 112.19 182.255C112.905 182.972 113.815 183.46 114.807 183.658C115.798 183.856 116.826 183.754 117.76 183.366C118.693 182.978 119.492 182.321 120.053 181.479C120.615 180.636 120.914 179.645 120.914 178.631C120.913 177.272 120.374 175.97 119.416 175.009C118.458 174.048 117.159 173.508 115.804 173.506Z",
					fill: "#3F3D56"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M71.3784 283C106.261 283 134.538 279.142 134.538 274.383C134.538 269.624 106.261 265.766 71.3784 265.766C36.4963 265.766 8.21875 269.624 8.21875 274.383C8.21875 279.142 36.4963 283 71.3784 283Z",
					fill: "#3F3D56"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M67.961 261.715C84.171 261.715 97.3117 248.537 97.3117 232.281C97.3117 216.025 84.171 202.847 67.961 202.847C51.7511 202.847 38.6104 216.025 38.6104 232.281C38.6104 248.537 51.7511 261.715 67.961 261.715Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M63.5026 255.382H54.5859V271.403H63.5026V255.382Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M81.3366 255.382H72.4199V271.403H81.3366V255.382Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M62.0165 274.383C66.1203 274.383 69.447 273.132 69.447 271.589C69.447 270.046 66.1203 268.794 62.0165 268.794C57.9127 268.794 54.5859 270.046 54.5859 271.589C54.5859 273.132 57.9127 274.383 62.0165 274.383Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M79.8505 274.011C83.9543 274.011 87.281 272.76 87.281 271.216C87.281 269.673 83.9543 268.422 79.8505 268.422C75.7467 268.422 72.4199 269.673 72.4199 271.216C72.4199 272.76 75.7467 274.011 79.8505 274.011Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M68.7051 234.889C74.2452 234.889 78.7363 230.386 78.7363 224.83C78.7363 219.274 74.2452 214.77 68.7051 214.77C63.165 214.77 58.6738 219.274 58.6738 224.83C58.6738 230.386 63.165 234.889 68.7051 234.889Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M68.7051 228.183C70.5518 228.183 72.0488 226.682 72.0488 224.83C72.0488 222.978 70.5518 221.477 68.7051 221.477C66.8584 221.477 65.3613 222.978 65.3613 224.83C65.3613 226.682 66.8584 228.183 68.7051 228.183Z",
					fill: "#3F3D56"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M39.4915 204.909C37.1216 194.265 44.6973 183.51 56.4124 180.887C68.1275 178.263 79.5456 184.765 81.9155 195.409C84.2855 206.053 76.5215 209.978 64.8064 212.602C53.0914 215.225 41.8615 215.552 39.4915 204.909Z",
					fill: "#0077C8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M57.9298 177.139C74.1397 177.139 87.2805 163.961 87.2805 147.705C87.2805 131.449 74.1397 118.271 57.9298 118.271C41.7198 118.271 28.5791 131.449 28.5791 147.705C28.5791 163.961 41.7198 177.139 57.9298 177.139Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M53.4723 170.805H44.5557V186.826H53.4723V170.805Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M71.3063 170.805H62.3896V186.826H71.3063V170.805Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M51.9862 189.807C56.09 189.807 59.4168 188.556 59.4168 187.013C59.4168 185.469 56.09 184.218 51.9862 184.218C47.8824 184.218 44.5557 185.469 44.5557 187.013C44.5557 188.556 47.8824 189.807 51.9862 189.807Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M69.8202 189.434C73.924 189.434 77.2508 188.183 77.2508 186.64C77.2508 185.097 73.924 183.846 69.8202 183.846C65.7164 183.846 62.3896 185.097 62.3896 186.64C62.3896 188.183 65.7164 189.434 69.8202 189.434Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M58.6738 150.313C64.2139 150.313 68.7051 145.809 68.7051 140.254C68.7051 134.698 64.2139 130.194 58.6738 130.194C53.1337 130.194 48.6426 134.698 48.6426 140.254C48.6426 145.809 53.1337 150.313 58.6738 150.313Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M58.6728 143.607C60.5196 143.607 62.0166 142.106 62.0166 140.254C62.0166 138.402 60.5196 136.9 58.6728 136.9C56.8261 136.9 55.3291 138.402 55.3291 140.254C55.3291 142.106 56.8261 143.607 58.6728 143.607Z",
					fill: "#3F3D56"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29.4593 120.333C27.0894 109.689 34.6651 98.9337 46.3802 96.3104C58.0952 93.6871 69.5134 100.189 71.8833 110.833C74.2532 121.477 66.4892 125.402 54.7742 128.025C43.0591 130.649 31.8292 130.976 29.4593 120.333Z",
					fill: "#0077C8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.1321 140.354C39.2224 138.049 34.1698 133.356 26.8468 129.873C19.5237 126.39 12.7033 125.436 11.6129 127.741C10.5226 130.047 15.5752 134.739 22.8983 138.222C30.2213 141.705 37.0417 142.66 38.1321 140.354Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M43.5137 158.324C43.5137 161.205 50.9103 166.893 59.1178 166.893C67.3254 166.893 75.0209 158.783 75.0209 155.902C75.0209 153.021 67.3254 156.461 59.1178 156.461C50.9103 156.461 43.5137 155.443 43.5137 158.324Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M288.369 100.027C304.579 100.027 317.72 86.8491 317.72 70.5932C317.72 54.3372 304.579 41.1592 288.369 41.1592C272.159 41.1592 259.019 54.3372 259.019 70.5932C259.019 86.8491 272.159 100.027 288.369 100.027Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M305.633 90.933L296.858 92.5259L299.704 108.291L308.478 106.698L305.633 90.933Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M288.087 94.122L279.312 95.7148L282.158 111.48L290.932 109.887L288.087 94.122Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M286.816 114.796C289.947 112.136 291.68 109.025 290.685 107.848C289.691 106.67 286.346 107.871 283.214 110.531C280.083 113.191 278.35 116.301 279.345 117.479C280.339 118.657 283.684 117.455 286.816 114.796Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M303.998 111.676C307.13 109.017 308.863 105.906 307.868 104.728C306.873 103.55 303.529 104.752 300.397 107.412C297.265 110.071 295.533 113.182 296.527 114.36C297.522 115.537 300.867 114.336 303.998 111.676Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M286.314 73.4532C291.855 73.4532 296.346 68.9493 296.346 63.3935C296.346 57.8376 291.855 53.3337 286.314 53.3337C280.774 53.3337 276.283 57.8376 276.283 63.3935C276.283 68.9493 280.774 73.4532 286.314 73.4532Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M282.192 63.1411C284.039 63.1411 285.536 61.6398 285.536 59.7878C285.536 57.9359 284.039 56.4346 282.192 56.4346C280.346 56.4346 278.849 57.9359 278.849 59.7878C278.849 61.6398 280.346 63.1411 282.192 63.1411Z",
					fill: "#3F3D56"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M311.524 38.5722C311.965 27.6753 302.6 18.4455 290.607 17.957C278.613 17.4684 268.532 25.906 268.091 36.8029C267.65 47.6998 275.987 50.1757 287.98 50.6643C299.974 51.1528 311.082 49.4691 311.524 38.5722Z",
					fill: "#0077C8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M275.574 68.5189C276.142 66.0318 270.199 62.5434 262.299 60.7275C254.398 58.9115 247.533 59.4556 246.965 61.9427C246.396 64.4298 252.34 67.9182 260.24 69.7341C268.14 71.5501 275.005 71.006 275.574 68.5189Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M333.188 78.1273C333.756 75.6402 327.813 72.1518 319.913 70.3359C312.013 68.5199 305.148 69.064 304.579 71.5511C304.011 74.0382 309.954 77.5266 317.854 79.3425C325.754 81.1585 332.619 80.6144 333.188 78.1273Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M296.431 82.1928C296.587 83.0594 296.572 83.9485 296.386 84.8092C296.2 85.6699 295.846 86.4853 295.346 87.2091C294.845 87.9328 294.208 88.5506 293.469 89.0272C292.731 89.5038 291.906 89.8298 291.042 89.9867C290.177 90.1436 289.291 90.1282 288.433 89.9415C287.574 89.7548 286.761 89.4004 286.04 88.8986C285.318 88.3967 284.702 87.7572 284.227 87.0166C283.751 86.276 283.426 85.4487 283.27 84.5821C282.612 80.9375 285.422 79.6478 289.056 78.988C292.691 78.3282 295.773 78.5481 296.431 82.1928Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M216.725 36.5905L216.272 37.1812L250.081 63.2619L250.535 62.6713L216.725 36.5905Z",
					fill: "#3F3D56"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M200.523 50.6712C214.476 50.6712 225.787 39.3281 225.787 25.3356C225.787 11.3431 214.476 0 200.523 0C186.57 0 175.259 11.3431 175.259 25.3356C175.259 39.3281 186.57 50.6712 200.523 50.6712Z",
					fill: "#E67300"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33.7837 270.76C36.5918 270.76 38.8682 268.477 38.8682 265.661C38.8682 262.845 36.5918 260.562 33.7837 260.562C30.9756 260.562 28.6992 262.845 28.6992 265.661C28.6992 268.477 30.9756 270.76 33.7837 270.76Z",
					fill: "#0077C8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M116.929 259.69H103.554V273.103H116.929V259.69Z",
					fill: "#E67300"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M103.631 273.74C106.439 273.74 108.716 271.457 108.716 268.641C108.716 265.825 106.439 263.542 103.631 263.542C100.823 263.542 98.5469 265.825 98.5469 268.641C98.5469 271.457 100.823 273.74 103.631 273.74Z",
					fill: "#0077C8"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_21_639",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 355.194,
				height: 283,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgHappy);
export default ForwardRef;
